import { render, staticRenderFns } from "./novoProjeto.vue?vue&type=template&id=885b7c18"
import script from "./novoProjeto.vue?vue&type=script&lang=js"
export * from "./novoProjeto.vue?vue&type=script&lang=js"
import style0 from "./novoProjeto.vue?vue&type=style&index=0&id=885b7c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports